// extracted by mini-css-extract-plugin
export default {"pointer":"styles_pointer__O0C0U","italic":"styles_italic__lC3JW"};